import api from './api'

export const createNewDiscount = newDiscountData =>
  api({
    method: 'post',
    url: '/api/crm/regular-discounts',
    data: newDiscountData,
  })

export const getDiscounts = async () => {
  const { data: discounts } = await api({
    method: 'get',
    url: '/api/crm/regular-discounts',
  })
  return discounts
}
